import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'

export const getShouldFetchTriggers = () =>
  Object.keys(AutomationRuleTriggersDataEnum).reduce(
    (obj, el) => {
      return { ...obj, [el]: false }
    },
    {} as Record<AutomationRuleTriggersDataEnum, boolean>,
  )
